import { render, staticRenderFns } from "./ApproveModal.vue?vue&type=template&id=a138674a&scoped=true&"
import script from "./ApproveModal.vue?vue&type=script&lang=js&"
export * from "./ApproveModal.vue?vue&type=script&lang=js&"
import style0 from "./ApproveModal.vue?vue&type=style&index=0&id=a138674a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a138674a",
  null
  
)

export default component.exports